import React from "react";
import BreadCrumb from "@/components/BreadCrumb";
import Map from "@/components/Maps";
import useFetchApi from "@/api/hooks/useFetchApi";
import { Formik } from "formik";
import * as yup from "yup";

const ContactUs = () => {
    const { data, isLoading } = useFetchApi({
        url: "/v1/gp/677e77112d638d2cfc867966/tr/find",
        service: "CMS_PROC"
    });

    // const { data: contactForm, isLoading: contactLoading } = useFetchApi({
    //     url: '/v1/user-form/678e4c5b9a8bb072c22925d1/action',
    //     service: 'CMS_PROC',
    //     options: {
    //         refreshInterval: 0,
    //         revalidateOnFocus: false,
    //     }
    // });

    // if (!contactForm || contactLoading) return <div>Loading...</div>;

    // // Build initial values and validation schema dynamically
    // const initialValues = contactForm.fields.reduce((acc: any, field: { column_name: string; default?: string }) => {
    //     acc[field.column_name] = field.default || "";
    //     return acc;
    // }, {});

    // const validationSchema = yup.object(
    //     contactForm.fields.reduce((acc: any, field: { column_name: string; type: string; rules: any[]; isMeta: boolean }) => {
    //         if (!field.isMeta) {
    //             let schema: any = null;
    //             if (field.type === "string" || field.type === "content") schema = yup.string();
    //             if (field.type === "number") schema = yup.number();
    //             if (field.type === "bool") schema = yup.boolean();
    //             if (field.type === "date") schema = yup.date();

    //             field.rules.forEach((rule: { rule: string; value: any; error_message: string }) => {
    //                 if (rule.rule === "required") schema = schema.required(rule.error_message);
    //                 if (rule.rule === "min") schema = schema.min(rule.value, rule.error_message);
    //                 if (rule.rule === "maxlength") schema = schema.max(rule.value, rule.error_message);
    //                 if (rule.rule === "pattern") schema = schema.matches(new RegExp(rule.value), rule.error_message);
    //             });

    //             acc[field.column_name] = schema;
    //         }
    //         return acc;
    //     }, {})
    // );

    return (
        <>
            <BreadCrumb title="İletişim" parent="" child="İletişim" />
            <section className="ls section_padding_top_100 section_padding_bottom_75">
                <div className="container">
                    {data && data.results.map((element: any, index: number) => (
                        <Map
                            key={`contact-us-maps-${index}`}
                            data={element}
                            isLoading={isLoading}
                        />
                    ))}

                    {/* <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={(values) => {
                            console.log("Form Values:", values);
                        }}
                    >
                        {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                            <form className="contact-form" onSubmit={handleSubmit}>
                                <div className="row">
                                    {contactForm.fields
                                        .filter((field: { isMeta: boolean }) => !field.isMeta)
                                        .map((field: { column_name: string; name: string; type: string; description?: string; rules: any[] }) => (
                                            <div className={`col-sm-6`} key={field.column_name}>
                                                <div className="form-group">
                                                    <label htmlFor={field.column_name}>{field.name}
                                                    </label>
                                                    {field.type === "content" ? (
                                                        <textarea
                                                            id={field.column_name}
                                                            name={field.column_name}
                                                            value={values[field.column_name]}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            required={field.rules.some((rule: { rule: string }) => rule.rule === "required")}
                                                            className={`form-control ${errors[field.column_name] && touched[field.column_name] ? "is-invalid" : ""}`}
                                                            placeholder={field.description || field.name}
                                                        />
                                                    ) : (
                                                        <input
                                                            id={field.column_name}
                                                            type={field.type === "string" ? "text" : field.type}
                                                            name={field.column_name}
                                                            value={values[field.column_name]}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            required={field.rules.some((rule: { rule: string }) => rule.rule === "required")}
                                                            className={`form-control ${errors[field.column_name] && touched[field.column_name] ? "is-invalid" : ""}`}
                                                            placeholder={field.description || field.name}
                                                        />
                                                    )}
                                                    {errors[field.column_name] && touched[field.column_name] && (
                                                        <div className="text-danger">
                                                            {errors[field.column_name] ? errors[field.column_name]?.toString() : "Invalid input"}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 text-center">
                                        <button type="submit" className="theme_button color1">Gönder</button>
                                    </div>
                                </div>
                            </form>
                        )}
                    </Formik> */}
                </div>
            </section>
        </>
    );
};

export default ContactUs;



// import React from "react";
// import BreadCrumb from "@/components/BreadCrumb";
// import Map from "@/components/Maps";
// import useFetchApi from "@/api/hooks/useFetchApi";

// const ContactUs: React.FC = () => {
//     const {
//         data,
//         isLoading,
//         error
//     } = useFetchApi({
//         url: "/v1/gp/677e77112d638d2cfc867966/tr/find",
//         service: "CMS_PROC"
//     })

//     const {
//         data: contactForm,
//         isLoading: contactLoading,
//         error: contactError
//     } = useFetchApi({
//         url: '/v1/user-form/678e4c5b9a8bb072c22925d1/action',
//         service: 'CMS_PROC',
//         options: {
//             refreshInterval: 0,
//             revalidateOnFocus: false,
//         }
//     })

//     return (
//         <>
//             <BreadCrumb title="İletişim" parent="" child="İletişim" />


//             <section className="ls section_padding_top_100 section_padding_bottom_75">
//                 <div className="container">

//                     {
//                         data && data?.results.map((element: any, index: number) => {
//                             return (
//                                 <Map
//                                     key={"contact-us-maps-" + index}
//                                     data={
//                                         element
//                                     }
//                                     isLoading={isLoading}
//                                 />
//                             )
//                         })
//                     }

//                     <div className="row">
//                         <div className="col-sm-12">
//                             <form className="contact-form" method="post" action="/">
//                                 <div className="row">
//                                     <div className="col-sm-6">
//                                         <div className="form-group">
//                                             <label htmlFor="name">Full Name
//                                                 <span className="required">*</span>
//                                             </label>
//                                             <input type="text" aria-required="true" size={30} name="name" id="name" className="form-control" placeholder="Full Name" />
//                                         </div>
//                                         <div className="form-group">
//                                             <label htmlFor="email">Email address
//                                                 <span className="required">*</span>
//                                             </label>
//                                             <input type="email" aria-required="true" size={30} name="email" id="email" className="form-control" placeholder="Email" />
//                                         </div>
//                                         <div className="form-group">
//                                             <label htmlFor="subject">Subject
//                                                 <span className="required">*</span>
//                                             </label>
//                                             <input type="text" aria-required="true" size={30} name="subject" id="subject" className="form-control" placeholder="Subject" />
//                                         </div>
//                                     </div>
//                                     <div className="col-sm-6">
//                                         <div className="form-group">
//                                             <label htmlFor="message">Message</label>
//                                             <textarea aria-required="true" rows={8} cols={45} name="message" id="message" className="form-control" placeholder="Message" defaultValue={""} />
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="row">
//                                     <div className="col-sm-12 text-center">
//                                         <button type="submit" id="contact_form_submit" name="contact_submit" className="theme_button color1">Send Message</button>
//                                     </div>
//                                 </div>
//                             </form>
//                         </div>
//                     </div>
//                 </div>
//             </section>

//         </>
//     )
// }

// export default ContactUs;